/** @format */

import { api } from "./api";
import { LocaleText } from "../../features/i18n/init";

export type MaintenancePeriod = {
  startDate: number;
  endDate: number;
  message: LocaleText;
};

export const adminApiSlice = api.injectEndpoints({
  endpoints: (build) => ({
    getNextMaintenance: build.query<
      { nextMaintenance: MaintenancePeriod | null },
      void
    >({
      query: () => "admin/maintenance/next",
    }),
  }),
});

export const { useGetNextMaintenanceQuery } = adminApiSlice;
